/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Menu } from 'antd';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { useRoutesDisplayValues } from 'hooks/useRoutesDisplayValues';
import { flatten, isArray } from 'lodash';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CustomScrollbars from 'utils/CustomScrollbars';

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting';
import SidebarLogo from './SidebarLogo';
import UserProfile from './UserProfile';

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { role } = useCurrentLoggedInUser();
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const { pathname } = useSelector(({ common }) => common);

  const routeNavigations = useRoutesDisplayValues();

  const getNoHeaderClass = (inputNavStyle) => {
    if (inputNavStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || inputNavStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  const generateNavigations = ([routeName, routeInfo]) => {
    if (
      routeInfo?.blocked ||
      (routeInfo.rolesAllowed && isArray(routeInfo.rolesAllowed) && !flatten([routeInfo.rolesAllowed]).includes(role))
    ) {
      return null;
    }

    return (
      <Menu.Item key={routeName} onClick={() => {}}>
        <Link to={routeName}>
          <i className={routeInfo.iconClass} />
          <span>{routeInfo.text}</span>
        </Link>
      </Menu.Item>
    );
  };
  const routeNavigationsAsArray = useMemo(() => Object.entries(routeNavigations), [routeNavigations]);
  let selectedKey = pathname;
  routeNavigationsAsArray.some(([routeName, routeValues]) => {
    if (routeName === pathname) return true;
    const isPathnameMatchedRouteMatchedNames =
      routeValues.matched_routes &&
      routeValues.matched_routes.some(
        (matchedRoute) =>
          matchedRoute.substring(0, matchedRoute.indexOf('/', 1)) === pathname.substring(0, pathname.indexOf('/', 1)),
      );
    if (isPathnameMatchedRouteMatchedNames) {
      selectedKey = routeName;
      return true;
    }
    return false;
  });
  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      <div className='gx-sidebar-content'>
        <div className={`gx-sidebar-notifications gx-p-3  ${getNoHeaderClass(navStyle)}`}>
          <UserProfile />
          {/* <AppsNavigation /> */}
        </div>
        <CustomScrollbars className='gx-layout-sider-scrollbar'>
          <Menu selectedKeys={[selectedKey]} theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'} mode='inline'>
            {routeNavigationsAsArray.map(generateNavigations)}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;
